import List from '@/components/SavItemsCardsList.vue'
import SavFoldCard from '@/components/SavFoldCard'
import SavDynamicForm from '@/components/SavDynamicForm'
import SavInput from '@/components/SavInput'
import SavButton from '@/components/SavButton'
import SavItemsCardsList from '@/components/SavItemsCardsList'
import SavForm from '@/components/SavForm'
import SavMap from '@/components/SavMap'
import SavMapInput from '@/components/SavMapInput'
import SavSpinner from '@/components/SavSpinner'
import SavTimelineForm from '@/components/SavTimelineForm'
import SavDistance from '@/components/SavDistance'
import SavModal from '@/components/SavModal'
import SavAddressInput from '@/components/SavAddressInput'
import PhotoTaker from '@/components/PhotoTaker'

export default {
    'list-items': List,
    'sav-timeline-form': SavTimelineForm,
    'sav-fold-card': SavFoldCard,
    'sav-dynamic-form': SavDynamicForm,
    'sav-input': SavInput,
    'sav-button': SavButton,
    'sav-items-cards-list': SavItemsCardsList,
    'sav-form': SavForm,
    'sav-map': SavMap,
    'sav-map-input': SavMapInput,
    'sav-spinner': SavSpinner,
    'b-spinner': SavSpinner,
    'sav-distance': SavDistance,
    'modal': SavModal,
    'sav-address-input': SavAddressInput,
    'photo-taker': PhotoTaker,
}



// WEBPACK FOOTER //
// ./src/companies/default/components/conf.js